"use client";
import { BlockProps } from "@/utils/types";
import { BlockWrapper } from "./BlockWrapper";
import { Heading } from "../modules/Heading";
import { Form } from "./Form";
import { Text } from "@/components/modules/FormFields/Text";
import { sanitize } from "@/utils/sanitize";

interface SignUpProps extends BlockProps {
  copy?: string;
}

export const SignUp = ({
  backgroundColor = "pattern",
  bottom,
  className,
  colorStarter,
  copy,
  componentId,
  heading = {
    copy: "Sign Up for our Newsletter",
    width: 440,
    lineThickness: 4,
    waveColor: "#fff",
  },
  primaryEnder,
}: SignUpProps) => {
  const blockProps = {
    backgroundColor,
    bottom,
    colorStarter,
    componentId,
    heading,
    primaryEnder,
  };
  return (
    <BlockWrapper
      {...blockProps}
      heading={undefined}
      className={`signUp${className ? ` ${sanitize(className)}` : ""}`}
    >
      <div className="contained">
        <div
          className={`text-center md:text-left max-w-[747px] mx-auto rounded-[59px] py-[90px] px-4 ${sanitize(backgroundColor) === "bg-tertiary" ? "bg-secondary" : "bg-tertiary"}`}
        >
          <div className="max-w-[448px] mx-auto flex flex-col gap-8">
            {heading && (
              <Heading
                {...heading}
                className="text-primaryDark"
                noPad
                waveColor="#fff"
              />
            )}
            <div className="px-8 md:px-0 flex flex-col gap-8">
              <p className="text-primaryDark font-semibold text-pretty">
                {copy}
              </p>
              <Form
                onSubmit={async (event) => {
                  event.preventDefault();
                  const form = event.target as HTMLFormElement;
                  const formData = new FormData(form);
                  const email = formData.get("email_email") as string;

                  const res = await fetch("/api/newsletter", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email }),
                  });

                  const data = await res.json();

                  console.log({
                    email,
                    response: data,
                    responseStatus: res.status,
                  });

                  if (!res.ok) {
                    console.error(`Error: ${data.error}`);
                  } else {
                    console.log("Thanks for subscribing!");
                  }
                }}
              >
                <Text
                  type="email"
                  hideLabel
                  required
                  label="Email"
                  id="email"
                  placeholder="E-mail"
                />
              </Form>
            </div>
          </div>
        </div>
      </div>
    </BlockWrapper>
  );
};
